import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ViewUI from "view-design";
import "view-design/dist/styles/iview.css";
import axios from "./api/api.js";
import "./assets/icon/iconfont.css";
import "./assets/icon/iconfont.js";
import VueCoreVideoPlayer from "vue-core-video-player";
import cookies from "vue-cookies";
import setRem from "@/util/toolRem.js";
import global_ from "./global.js";
import mavonEditor from "mavon-editor";
import "mavon-editor/dist/css/index.css";

Vue.use(mavonEditor);
Vue.use(cookies);
Vue.use(VueCoreVideoPlayer, {
  lang: "zh-CN"
});
Vue.prototype.$GLOBAL = global_;
Vue.prototype.$cookies = cookies;
Vue.prototype.setRem = setRem;
cookies.config("1d");

Vue.use(ViewUI);
ViewUI.Message.config({
  background: true
});
Vue.config.productionTip = false;
Vue.prototype.$axios = axios;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
